<template>
  <div>
    <div class="mb-10">
      <el-button type="primary" @click="open">添加素材</el-button>
    </div>
    <material-box-view
      :channel-interface="channelInterface"
      :material-data="materialData"
      :is-show-border="true"
    />
    <material-box
      v-if="material_config.is_show"
      ref="material_box_ref"
      :advertiser="channelInterface"
      :is-open="material_config.is_show"
      v-bind="material_config.props"
      @confirm="confirm"
      @cancel="cancel"
      @hook:mounted="onMaterialBoxMounted"
    />
  </div>
</template>

<script>
export default {
  components: {
    'material-box-view': () => import('@/components/business/material/material-box-view'),
    'material-box': () => import('@/components/material-box'),
  },
  props: {
    channelInterface: {
      type: String,
      required: true,
    },
    materialData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      material_config: {
        is_show: false,
        props: {
          type: 'image',
          tempMaterial: null,
        },
      },
    };
  },
  methods: {
    /**
     * 打开素材弹窗
     */
    open() {
      const { tab } = this.materialData;
      this.material_config.props.type = tab;
      this.material_config.is_show = true;
    },
    /**
     * 素材库确认
     * @param {Object[]} data 素材库选中的素材
     * @param {string} type 素材类型
     */
    confirm(data, type) {
      const base_type = type === 'element_story' ? 'image' : type;
      if (data.length === 0) {
        return;
      }
      this.materialData[`${base_type}s`] = data;
      this.material_config.is_show = false;
    },
    /** 素材库取消 */
    cancel() {
      this.material_config.is_show = false;
    },
    /**
     * 初始化素材库选中数据
     * @returns {void}
     */
    initMaterialsSelection() {
      const material_box_ref = this.$refs.material_box_ref;
      const { tab } = this.materialData;

      material_box_ref.select_file_arr.splice(0);
      material_box_ref.select_file_arr.push(...this.materialData[`${tab}s`]);
    },
    /**
     * 监听素材库挂载完成
     * @returns {void}
     */
    onMaterialBoxMounted() {
      this.initMaterialsSelection();
    },
  },
};
</script>
